export const GET_PERMISSIONS = 'GET_PERMISSIONS';
export const GET_PERMISSIONS_ERROR = 'GET_PERMISSIONS_ERROR';
export const GET_PERMISSIONS_REQUEST = 'GET_PERMISSIONS_REQUEST';
export const GET_PERMISSIONS_SUCCESS = 'GET_PERMISSIONS_SUCCESS';

export const SET_PERMISSIONS = 'SET_PERMISSIONS';
